import { IBrand } from 'data/schema';
import { Cache } from 'utils/cache';
import { sendApiRequest } from 'utils/network';
const cache = new Cache();

type DGAResponse = {
  id: string;
  url: string;
};

export type DgaRequest = {
  marketingCode: string;
  locale: string;
  market: string;
  dealerId: string;
  brand: IBrand;
  renderCameraFlight?: boolean;
};

const allowedLocales = ['en_CA', 'fr_CA', 'de_LU', 'fr_LU', 'de_CH', 'fr_CH', 'it_CH', 'fr_BE', 'nl_BE'];

export const getDGA = async (dga: DgaRequest, caching = true): Promise<DGAResponse | undefined> => {
  let response: DGAResponse | undefined = caching
    ? cache.getValue<DGAResponse>(`dga-${dga.brand}-${dga.market}-${dga.marketingCode}-${dga.renderCameraFlight}`)
    : undefined;

  if (response) {
    return response;
  }

  // Build the request body without locale first. Brand is sent only as a query param;
  // the lambda resolves the DGA API slug and OAuth scope from it.
  const body: Omit<DgaRequest, 'brand'> = {
    marketingCode: dga.marketingCode,
    market: dga.market,
    renderCameraFlight: dga.renderCameraFlight ?? false,
    dealerId: dga.dealerId,
    locale: '',
  };

  // We should only send the locale for markets that have multiple languages.
  // See https://collaboration.msi.audi.com/confluence/pages/viewpage.action?spaceKey=AVPHOMEC&title=DGA+API+-+Documentation for the list of those markets and more details
  if (allowedLocales.includes(dga.locale)) {
    body.locale = dga.locale;
  }

  response = await sendApiRequest<DGAResponse>(`/dga?brand=${dga.brand}`, {
    method: 'POST',
    body,
  });

  if (response) {
    cache.setValue(`dga-${dga.brand}-${dga.market}-${dga.marketingCode}-${dga.renderCameraFlight}`, response);
    return response;
  }
};
